import type { ReactNode } from 'react'

import { highlightParts } from './highlightParts'
import './highlight.css'

/**
 * Текст с подсвеченным совпадением запроса: на светлом фоне — жирным с мягким подчёркиванием,
 * на тёмном — жёлтым свечением. Подсветка не только цветом: жирность видна в любой теме.
 */
export function Highlight({ text, query }: { text: string; query: string }): ReactNode {
  const parts = highlightParts(text, query)
  if (parts.length === 1 && !parts[0]!.match) return text
  return (
    <>
      {parts.map((part, index) =>
        part.match ? (
          <mark key={index} className="krp-mark">
            {part.text}
          </mark>
        ) : (
          part.text
        ),
      )}
    </>
  )
}
